export enum TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey {
    inventory = "bf997be7-c187-47bb-ba9a-f42ff038b0cb",
    item = "2b042e62-ca7f-4b92-b283-1c9145a056a8",
    apiLog = "f177473e-c34a-4eab-8100-9cfe2891a227",
}
